/**
 * Por que a venda foi perdida (058).
 *
 * ── O catálogo é da revenda ──────────────────────────────────────────────
 *
 * "Preço", "crédito negado", "comprou no concorrente": cada revenda perde por
 * motivos seus, e a lista é escrita por quem administra. Lê quem lê
 * oportunidade, porque é quem escolhe o motivo ao levar o negócio para a perda.
 *
 * Motivo não se apaga, se desativa: sai da lista de escolha e continua
 * nomeando as perdas registradas com ele.
 */

import { z } from 'zod';
import { IdSchema } from './comum.js';

export const MotivoDePerdaSchema = z
  .object({
    id: IdSchema,
    texto: z.string(),
    /** Desativado não aparece para escolher; as perdas antigas continuam com ele. */
    ativo: z.boolean(),
  })
  .strict();

export type MotivoDePerda = z.infer<typeof MotivoDePerdaSchema>;

export const MotivosDePerdaSchema = z.object({ itens: z.array(MotivoDePerdaSchema) }).strict();

export type MotivosDePerda = z.infer<typeof MotivosDePerdaSchema>;

export const CriarMotivoDePerdaSchema = z
  .object({ texto: z.string().trim().min(1).max(80) })
  .strict();

export type CriarMotivoDePerda = z.infer<typeof CriarMotivoDePerdaSchema>;

export const EditarMotivoDePerdaSchema = z
  .object({
    texto: z.string().trim().min(1).max(80).optional(),
    ativo: z.boolean().optional(),
  })
  .strict()
  .refine((v) => v.texto !== undefined || v.ativo !== undefined, {
    message: 'Diga o que mudar: o texto, se está ativo, ou os dois.',
  });

export type EditarMotivoDePerda = z.infer<typeof EditarMotivoDePerdaSchema>;

/**
 * O que vai junto quando a oportunidade é levada para uma etapa de PERDA.
 *
 * `motivo_id` nulo só vale quando a revenda não tem motivo nenhum ativo: a
 * perda é registrada assim mesmo, porque escondê-la tiraria a venda perdida da
 * conversão. Havendo motivo, ele é obrigatório.
 */
export const PerdaDaOportunidadeSchema = z
  .object({
    motivo_id: IdSchema.nullable(),
    observacao: z.string().trim().max(500).optional(),
  })
  .strict();

export type PerdaDaOportunidade = z.infer<typeof PerdaDaOportunidadeSchema>;
